import { Clickable } from '@ahmdigital/ui';
import { PRODUCT_TYPE } from '@ahmdigital/constants';

import { buildNavigationUrl } from '../../../../../utils/navigation';
import { BuildYourCoverProductType } from '../../../../../../../actions/build-your-cover';
import { useByocNavigationContext } from '../../../../../context/byoc-navigation-context';
import styles from './styles.module.sass';

const RemoveProductType = ({ productType }: { productType: BuildYourCoverProductType }) => {
  const { activeSlug, journeyType } = useByocNavigationContext();

  const isBundleJourney = journeyType === PRODUCT_TYPE.PACKAGE;
  if (!isBundleJourney) {
    return null;
  }

  const alternateJourneyType = productType === PRODUCT_TYPE.HOSPITAL ? PRODUCT_TYPE.EXTRAS : PRODUCT_TYPE.HOSPITAL;
  const urlForAlternativeJourney = buildNavigationUrl(activeSlug, alternateJourneyType);

  return (
    <Clickable to={urlForAlternativeJourney} variant={styles.removeProductType}>
      I don’t want {productType} cover
    </Clickable>
  );
};

export default RemoveProductType;
